import hotkeys, { HotkeysEvent } from 'hotkeys-js';

const unbindList: any[] = [];

class ShortcutService {

  static on(keys: string, listener: Function): Function {

    const innerListener = (evt: KeyboardEvent, handler: HotkeysEvent): void => {
      listener(evt, { key: handler.key });
    };

    hotkeys(keys, innerListener);

    const unbindFn = (): void => hotkeys.unbind(keys, innerListener);

    unbindList.push(unbindFn);

    return unbindFn;
  }

  unbindAll(): void {
    unbindList.forEach(fn => fn());
  }

}

export default ShortcutService;
